import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box, TextField } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import PageWaiting from '../../../core/components/PageWaiting';
import IconEnabled from 'core/components/layout/IconEnabled';
import IconDisabled from 'core/components/layout/IconDisabled';
import { useDispatch, useSelector } from 'react-redux';
import MforderListTableHeader from './MforderListTableHeader';
import MforderListTableRow from './MforderListTableRow';
import { setSelectedMforderId } from 'store/slice/ManufSlice';
import { use } from 'react';

export default function MforderListTable({ payload }) {
  const dispatch = useDispatch();
  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const { userprofileInfo } = useSelector((state) => state.headerslice);
  const [clickedRowId, setClickedRowId] = useState(-1)
  const { mforderList } = useSelector((state) => state.manufslice.mforderDashboard);
  const {mfproductorderList} = useSelector((state) => state.manufslice.mfproductorderDashboard);

  // Filter states
  const [partyFilter, setPartyFilter] = useState('');
  const [productFilter, setProductFilter] = useState('');

  useEffect(() => {
    if (mforderList.length !== 0)
      setRows(mforderList);
  }, [mforderList])

  // Filtered rows based on partyname and productname (with product filter using mfproductorderList)
  const filteredRows = rows.filter(row => {
    // Party filter as before
    const partyMatch = !partyFilter || (row.partyname && row.partyname.toLowerCase().includes(partyFilter.toLowerCase()));

    // Product filter: check in mfproductorderList for matching productname, then match orderid
    let productMatch = true;
    if (productFilter) {
      const matchingProductOrders = mfproductorderList.filter(
        po =>
          po.productname &&
          po.productname.toLowerCase().includes(productFilter.toLowerCase())
      );
      // If any product order matches and its orderid matches this row's id, show this row
      productMatch = matchingProductOrders.some(po => po.orderid === row.id);
    }

    return partyMatch && productMatch;
  });

  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      {payload.actionList
        .filter(actionObj =>
          actionObj.status !== undefined &&
          actionObj.status.toLowerCase().includes(rowObj.orderstatusname.toLowerCase())
        )
        .map(actionObj => (
          <IconEnabled key={`${rowObj.id}-${actionObj.status}`} actionObj={actionObj} id={rowObj.id} />
        ))
      }
    </>
  }

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        {/* Filter Inputs */}
        <Grid item sx={{ width: '100%',padding:1}}>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <TextField
              label="Filter by Party Name"
              size="small"
              value={partyFilter}
              onChange={e => setPartyFilter(e.target.value)}
              sx={{ minWidth: 200 }}
            />
            <TextField
              label="Filter by Product Name"
              size="small"
              value={productFilter}
              onChange={e => setProductFilter(e.target.value)}
              sx={{ minWidth: 200 }}
            />
          </Box>
        </Grid>
        {/* <HEADER/> */}
        <Grid item sx={{ width: '100%', paddingBottom: .2 }}>
          < MforderListTableHeader />
        </Grid>
        {/* <ROWS/> */}
        <Grid item sx={{ width: '100%' }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '65vh' }}>
              <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", width: '100%' }}>
                {filteredRows.map(obj => {
                  return (
                    <MforderListTableRow obj={obj} getActionComponent={getActionComponent} handleRowClick={handleRowClick} actionList={payload.actionList}/>
                  )
                })}
                {
                  filteredRows.length === 0 ?
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: '100%', backgroundColor: '#fafafa' }}
                      padding={1}
                    >
                      <Typography sx={{ fontWeight: 'light', fontSize: 14 }}><i>Records(s) are not added, yet.</i></Typography>
                    </Grid>
                    : <></>
                }
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}